// extracted by mini-css-extract-plugin
module.exports = {"TabSwriper":"TabSwriper_TabSwriper__6sqCB"};